import { useEffect } from "react";
import { useDepositWithBody } from "./useDepositWithBody";
import { useMutation } from "@tanstack/react-query";

export interface IHydrozoaHeadInfoData {
  headId: string;
  headAddress: string;
  multisigRegimeUtxo: {
    transaction_id: string;
    index: number;
  };
  submissionDurationSeconds: number;
  refundStartOffsetSeconds: number;
  currentTimePosixSeconds: number;
  maxNonPlutusTxFee: string;
  absorptionStartOffsetSeconds?: number;
}

export const useHydrozoaHeadInfo = () => {
  const { mutate, data } = useMutation<IHydrozoaHeadInfoData, Error>({
    mutationKey: ["head-info"],
    mutationFn: async () => {
      const response = await fetch(
        `${window.__APP_CONFIG.hydrozoaApi}/head-info`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(
          `Hydrozoa head info request failed with status ${response.status}`,
        );
      }

      return response.json();
    },
  });

  useEffect(() => {
    mutate();
  }, []);

  return data;
};

/**
 * @deprecated Use `useHydrozoaHeadInfo()` instead for full head info access.
 */
export const useHydrozoaScriptAddress = () => {
  return useHydrozoaHeadInfo()?.headAddress;
};
